import React from 'react';
// import { useLanguage } from '../../../../store/languageContext';
// import { LanguageFactory } from '../../../../factories';
import { Button, Row, Col, Tag, Card} from 'antd';
import './../../index.module.css'
import styles from './../../index.module.css';
import DetailItem from './../../../CSIComponents/DetailItem';
import PageContainer from '../../../CSIComponents/PageContainer';
import { isTagsDisplayed } from '@helpers/FeatureFlags'

const AttractionDetailView = (props: any) => {
  // const { language, setLanguage } = useLanguage()
  // const lang = new LanguageFactory(language)

  return (
    <PageContainer>
      <Card style={{marginTop:-15}}>
      <div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{ margin: '0 10px 0 0' }}>
            <Button type='primary' className="db-edit-btn" onClick={() => props.setCurrentFlag('table')}>Back</Button>
          </div>
          <div>
            <Button type='primary' className="db-edit-btn" onClick={() => { props.setCurrentFlag('edit') }}>Edit</Button>
          </div>
        </div>
        <div className={styles.detailViewHead}>
          <div className={styles.detailViewName} style={{ marginTop: -25}}>{props.currentLine.name}</div>
        </div>
        <div className={styles.inCon}>
          <Row gutter={24}>
            <Col span={6} className={styles.colMargin}>
              <DetailItem value={props.currentLine.name} label='Name' />
            </Col>
            <Col span={6} className={styles.colMargin}>
              <DetailItem value={props.currentLine.id} label='Attraction ID' />
            </Col>
            <Col span={6} className={styles.colMargin}>
              <DetailItem value={props.currentLine.url} label='Website URL' />
            </Col>
            <Col span={5}></Col>
            <Col span={18} className={styles.colMargin}>
              <DetailItem value={props.currentLine.desc} label='Description' />
            </Col>
            <Col span={5}></Col>
            <Col span={6} className={styles.colMargin}>
              <DetailItem value={props.currentLine.typestandard} label='Type Standard' />
            </Col>
            <Col span={6} className={styles.colMargin}>
              <DetailItem value={props.currentLine.type} label='Type' />
            </Col>
            <Col span={6} className={styles.colMargin}>
              <DetailItem value={props.currentLine.proximity} label='Proximity' />
            </Col>
            <Col span={5}></Col>
            <Col span={18} className={styles.colMargin}>
              <DetailItem value={props.currentLine.typedetail} label='Type Detail' />
            </Col>
            <Col span={5}></Col>
            <Col span={6} className={styles.colMargin}>
              <DetailItem value={props.currentLine.rank} label='Rank' />
            </Col>
            <Col span={6} className={styles.colMargin}>
              <DetailItem value={props.currentLine.season} label='Season' />
            </Col>
            <Col span={6} className={styles.colMargin}>
              <DetailItem value={props.currentLine.guesttype} label='Guest Type' />
            </Col>
            <Col span={5}></Col>
            <Col span={6} className={styles.colMargin}>
              <DetailItem value={props.currentLine.startdate} label='Start/End Date' />
            </Col>
            <Col span={6} className={styles.colMargin}>
              <DetailItem value={props.currentLine.enddate} label='' />
            </Col>
            <Col span={6} className={styles.colMargin}>
              <DetailItem value={props.currentLine.crossstreet} label='Cross Street Name' />
            </Col>
            <Col span={5}></Col>
            { isTagsDisplayed && 
              <Col span={18} className={styles.colMargin}>
                <div className={styles.detailViewTagsCon}>
                  <div className={styles.detailViewTagsLabel}>Available Tags</div>
                  <div className={styles.detailViewTags}>
                    {
                      props.currentLine.tags ? props.currentLine.tags.split(' | ').map((item: any, index: any) => {
                        return <Tag key={index}>{item}</Tag>
                      }) : 'None'
                    }
                  </div>
                </div>
              </Col>
            }
            <Col span={5}></Col>
          </Row>
        </div>
      </div>
      </Card>
    </PageContainer>
  )
}
export default AttractionDetailView;
